<template>
  <div>
    <a-row :gutter="[8, 8]">
      <a-col v-for="(item, index) in templateList" :key="index" :span="8">
        <a-card :class="className(item.token)" size="small" @click="onSelect(item.token)">
          <a :href="item.url" target="_blank" class="template-name">{{ item.name }}</a>
          <a-icon v-if="item.token === selected" class="active-icon" type="check-circle" theme="filled" />
          <div style="text-align: center; font-size: 80px; color: #bfbfbf; margin-top: 16px"><a-icon type="read" /></div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },

  data() {
    return {};
  },

  computed: {
    className() {
      return value => {
        return value === this.selected ? 'template-card  active' : 'template-card';
      };
    },
    templateList() {
      return this.$store.state.globalConfigList.document_template || [];
    },
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  methods: {
    onSelect(value) {
      this.selected = value;
    }
  }
};
</script>

<style lang="less" scoped>
.template-card {
  width: 160px;
  height: 180px;
  cursor: pointer;
  border-radius: 12px;
}
.template-name {
  width: 120px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出显示省略号 */
  white-space: nowrap; /* 文本不会换行 */
  vertical-align: bottom; /* 处理inline-block导致的元素上浮问题 */
}

.template-name:hover {
  color: #1890ff;
}

.active,
.template-card:hover {
  border-color: #1890ff;
}

.active-icon {
  position: absolute;
  color: #1890ff;
  font-size: 16px;
  right: 8px;
}

.template-action {
  text-align: center;
  width: 134px;
}
</style>
